/**
 * English: Area chart showing daily token usage and cost over time.
 * Thai: Area chart แสดง token usage และ cost รายวัน
 */
import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid,
} from 'recharts';

interface DailyRow {
  date: string;
  calls: number;
  tokens: number;
  cost_usd: number;
}

interface TokenUsageChartProps {
  data: DailyRow[];
}

export default function TokenUsageChart({ data }: TokenUsageChartProps) {
  if (!data.length) return null;

  const sorted = [...data].sort((a, b) => a.date.localeCompare(b.date));

  return (
    <ResponsiveContainer minWidth={1} minHeight={1} width="100%" height={240}>
      <AreaChart data={sorted} margin={{ top: 8, right: 8, bottom: 0, left: -16 }}>
        <CartesianGrid
          strokeDasharray="3 3"
          stroke="rgb(var(--color-app-border))"
          strokeOpacity={0.5}
        />
        <XAxis
          dataKey="date"
          tick={{ fontSize: 11, fill: 'rgb(var(--color-app-text-dim))' }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(d: string) => d.slice(5)}
        />
        <YAxis
          tick={{ fontSize: 11, fill: 'rgb(var(--color-app-text-dim))' }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(v: number) => v >= 1000 ? `${(v / 1000).toFixed(0)}k` : String(v)}
        />
        <Tooltip
          contentStyle={{
            background: 'rgb(var(--color-app-surface))',
            border: '1px solid rgb(var(--color-app-border))',
            borderRadius: 8,
            fontSize: 13,
          }}
          labelStyle={{ color: 'rgb(var(--color-app-text))' }}
        />
        <Area
          type="monotone"
          dataKey="tokens"
          name="Tokens"
          stroke="rgb(var(--color-app-accent))"
          fill="rgb(var(--color-app-accent))"
          fillOpacity={0.15}
          strokeWidth={2}
        />
        <Area
          type="monotone"
          dataKey="calls"
          name="Calls"
          stroke="rgb(var(--color-app-success))"
          fill="rgb(var(--color-app-success))"
          fillOpacity={0.1}
          strokeWidth={2}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
